import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { loadNavProducts } from '../ducks/shared';

class ProductProvider extends Component {
  componentDidMount() {
    this.props.loadNavProducts();
  }
  render() {
    return (
      <div>
        {React.Children.map(this.props.children, child => {
          return React.cloneElement(child, {
            userManager: this.props.userManager,
            user: this.props.user,
            navigation: this.props.navigation
          });
        })}
      </div>
    );
  }
}

ProductProvider.propTypes = {
  navigation: PropTypes.array.isRequired,
  loadNavProducts: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  userManager: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired
};

const mapState = ({ shared }) => ({ navigation: shared.navigation });
const mapDispatch = dispatch => ({
  loadNavProducts: bindActionCreators(loadNavProducts, dispatch)
});

export default withRouter(connect(mapState, mapDispatch)(ProductProvider));



// WEBPACK FOOTER //
// ./src/common/jsx/auth/ProductProvider.js